import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./feedback.modal.container").then(({ FeedbackModalContainer: F }): { default: FC } => ({
            default: F
        }))
)

const Modal: FC = (): ReactElement => <ModalContainer modalId={EModalId.Feedback} container={Container} />

export { Modal as FeedbackModal }
